import { z } from 'zod';
import type { ConnectionProvider } from './data-connections.js';

/**
 * What a caller asks a data connection for. One variant per request shape, discriminated by `kind`
 * rather than by connection provider, so providers that share a shape share a variant. To support a new
 * provider, add a variant here and map the provider in CONNECTION_REQUEST_KIND_BY_PROVIDER.
 */
export const HttpConnectionRequestSchema = z.object({
  kind: z.literal('http'),
  /** Path appended to the connection's base URL (e.g. "/widgets/trx") */
  path: z.string(),
});
export const ConnectionRequestSchema = z.discriminatedUnion('kind', [HttpConnectionRequestSchema]);
export type ConnectionRequest = z.infer<typeof ConnectionRequestSchema>;
export type ConnectionRequestKind = ConnectionRequest['kind'];
/** Every ConnectionRequest `kind`. Add new kinds here too; `satisfies` rejects kinds the union doesn't have. */
export const ConnectionRequestKindSchema = z.enum(['http'] as const satisfies readonly ConnectionRequestKind[]);

/**
 * The request kind each connection provider serves. A provider missing here can't be sent a
 * ConnectionRequest: it isn't offered as a widget data source, and a request whose `kind` doesn't match
 * its connection's provider is rejected.
 */
export const CONNECTION_REQUEST_KIND_BY_PROVIDER: Readonly<Partial<Record<ConnectionProvider, ConnectionRequestKind>>> = {
  SPECIFIC_HOST: 'http',
};
